import http from '@/core/http';
import {
  IZoneHandlerByActionReq,
  IZoneParseListReq,
  IZoneParseListRes,
  IZoneParseLogListReq,
  IZoneParseLogListResListItem,
} from './type';

/**
 * 域名管理平台
 * 域名管理页面-获取列表页
 */
export function getZoneParseList(data: IZoneParseListReq) {
  return http.post<IZoneParseListRes>({
    url: '/monitor/zone/parse-list',
    loading: true,
    data,
  });
}

/**
 * 域名管理平台
 * 域名管理页面-【禁用/启用】 或 【删除】 操作
 */
export function updateZoneStatus(data: IZoneHandlerByActionReq) {
  return http.post({
    url: '/monitor/zone/handler-by-action',
    loading: true,
    data,
  });
}

/**
 * 域名管理平台
 * 日志管理页面-获取列表
 */
export function getZoneParseLogList(data: IZoneParseLogListReq) {
  return http.post<IZoneParseLogListResListItem>({
    url: '/monitor/zone/parse-log-list',
    loading: true,
    data,
  });
}
